export default {
  mounted() {
    this.handleEvent("scroll_to_bottom", () => {
      this.el.scrollTop = this.el.scrollHeight;
    });
    // Once initially when the page loads
    this.el.scrollTop = this.el.scrollHeight;
  },
}